export default __webpack_public_path__ + "static/media/Manage_roles.855bf0f5.svg";